import { ILogModel } from "../interfaces/ILogModel";
import { ISolicitudPersonaModel } from "../interfaces/solicitud/ISolicitudPersonaModel";
import { DocumentacionRequeridaModel } from "./DocumentacionRequeridaModel";

export class PersonalDialogModel {
    persona: PersonalModel;
    documentacionRequerida: DocumentacionRequeridaModel[];
    enableEdit: boolean;

    constructor() {
        this.persona = new PersonalModel();
        this.documentacionRequerida = new Array<DocumentacionRequeridaModel>();
        this.enableEdit = true;
    }
}

export class PersonalModel implements ISolicitudPersonaModel {
    idSolicitud: number;
    idSede: number;
    idContratista?: number;
    codigoSolicitud: string;
    idSolicitudPersona: number;
    nombres: string;

    apellidoPaterno: string;

    apellidoMaterno: string;

    idTipoDocumentoIdentidad: number;
    idTipoDocumentoIdentidadSelected?: number;
    nroDocumentoIdentidad: string;

    cargo: string;
    correo: string;

    idEstado: number;
    estado: string;

    blnEstado: boolean;

    documentos_requeridos: Array<DocumentacionRequeridaModel>;
    documentos: Array<DocumentacionRequeridaModel>;
    documentosRequeridos: Array<DocumentacionRequeridaModel>;

    fechaVencimiento?: boolean;

    comentarios: string;
    documentosRevisados: number;

    enableEdit: boolean;
    logs: ILogModel[] = [];
    notificarCambio: boolean;
    completado: boolean;

    constructor() {
        this.idSolicitud = 0;
        this.idSede = 0;
        this.idContratista = 0;
        this.codigoSolicitud = '';
        this.idSolicitudPersona = 0;
        this.nombres = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.idTipoDocumentoIdentidad = 0;
        this.nroDocumentoIdentidad = '';
        this.cargo = '';
        this.idEstado = 0;
        this.estado = '';
        this.blnEstado = false;
        this.documentos_requeridos = new Array<DocumentacionRequeridaModel>();
        this.documentosRequeridos = new Array<DocumentacionRequeridaModel>();
        this.documentos = new Array<DocumentacionRequeridaModel>();
        this.comentarios = '';
        this.enableEdit = true;
        this.correo = '';
        this.documentosRevisados = 0;
        this.notificarCambio = false;
        this.completado = false;
    }
}